import React, { useState, useEffect, useRef } from "react";
import GridItem from "../../../Components/UiComponents/GridItem/GridItem";
import { GridStack } from "gridstack";
import DMSHeader from "../DMSHeader/DMSHeader";
import MyTaskList from "./MyTaskList/MyTaskList";
import MyIndividualTaskList from "../MyIndividualTaskListManagement/MyIndividualTaskList/MyIndividualTaskList";
import Accordion from "react-bootstrap/Accordion";
import Card from "react-bootstrap/Card";
import "./MyTaskListManagement.css";
import { useTranslation } from "react-i18next";
import { getTaskCount } from "../../../Services/EndPoints";
import { deleteDataById, getData, postDataWithBody } from "../../../Services/Services";
import { useKeycloak } from "@react-keycloak/web";
import { toast } from "react-toastify";

const MyTaskListManagement = () => {
  const { t, i18n } = useTranslation();
  const myIndividualTaskListRef = useRef(null);
  const mySopRef = useRef(null);

  // State to store task counts
  const [taskCounts, setTaskCounts] = useState({
    DS: 0,
    SOP: 0
  });

  useEffect(() => {
    GridStack.init();
  }, []);

  const { keycloak, initialized } = useKeycloak();
  
  useEffect(() => {
    if (keycloak.authenticated) {
      fetchTaskCounts();
    }
  }, [keycloak.authenticated]);

  const getLoggedInuserName = () => {
    return keycloak.idTokenParsed.email;
  };

  const fetchTaskCounts = async () => {
    try {
      const userEmail = getLoggedInuserName();
    
      const dsRequestBody = { email: userEmail, type: 'DS' };
      const sopRequestBody = { email: userEmail, type: 'SOP' };
      const [dsCountResponse, sopCountResponse] = await Promise.all([
        postDataWithBody(getTaskCount, dsRequestBody,
      {}),
        postDataWithBody(getTaskCount, sopRequestBody,
      {})
      ]);

      const dsCount = Array.isArray(dsCountResponse) && dsCountResponse.length > 0 
        ? dsCountResponse[0].count || 0 
        : 0;
      
      const sopCount = Array.isArray(sopCountResponse) && sopCountResponse.length > 0 
        ? sopCountResponse[0].count || 0 
        : 0;
      setTaskCounts({
        DS: dsCount,
        SOP: sopCount
      });

      console.log('Updated task counts:', { DS: dsCount, SOP: sopCount });

    } catch (error) {
      console.error("Error fetching task counts:", error);
      
      if (error.response) {
        console.error("Error response:", error.response);
        console.error("Error status:", error.response.status);
        console.error("Error data:", error.response.data);
      }
      
      toast.error(t("fetch_error_message") || "Error fetching task counts", {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 2000,
      });
      
      setTaskCounts({
        DS: 0,
        SOP: 0
      });
    }
  };

  const handleRefreshDailyTasks = () => {
    if (
      myIndividualTaskListRef.current &&
      myIndividualTaskListRef.current.refreshTaskList
    ) {
      myIndividualTaskListRef.current.refreshTaskList();
    }
    fetchTaskCounts();
  };

  const handleRefreshsopTask = () => {
    if (
      mySopRef.current &&
      mySopRef.current.refreshSopList
    ) {
      mySopRef.current.refreshSopList();
    }
    fetchTaskCounts();
  };

  const layoutData = [
    {
      x: 0,
      y: 0,
      width: 12,
      height: 1,
      id: 1,
      component: (
        <DMSHeader
          title={t("daily_operational_task_header")}
          showmenu={true}
          showImportDropDownLabel={false}
        />
      ),
      haveOverflowVisible: true,
    },
    {
      x: 0,
      y: 1,
      width: 12,
      height: 6,
      id: 2,
      component: <MyIndividualTaskList />,
    },
  ];

  const MyIndividualTaskListlayoutData = [
    {
      x: 0,
      y: 2,
      width: 12,
      height: 1,
      id: 1,
      component: (
        <DMSHeader
          title={t("sop_related_task_header")}
          showmenu={true}
          showImportDropDownLabel={false}
        />
      ),
      haveOverflowVisible: true,
    },
    {
      x: 0,
      y: 3,
      width: 12,
      height: 6,
      id: 2,
      component: <MyTaskList />,
    },
  ];

  return (
    <div>
    <Accordion defaultActiveKey="0" flush>
        <Accordion.Item eventKey="0">
          <Accordion.Header>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                width: "100%",
              }}
            >
              <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                <span style={{fontSize:"1rem"}}>{t("daily_operational_task_header")}</span>
              </div>

              <div style={{ display: "flex", alignItems: "center", gap: "12px", marginRight:'20px' }}>
                <div style={{ position: "relative", display: "inline-block" }}>
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="white"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
                    <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
                  </svg>
                  {taskCounts.DS > 0 && (
                    <span
                      style={{
                        position: "absolute",
                        top: "-8px",
                        right: "-8px",
                        backgroundColor: "#dc3545",
                        color: "white",
                        borderRadius: "50%",
                        minWidth: "18px",
                        height: "18px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontSize: "12px",
                        fontWeight: "600",
                        lineHeight: "1",
                        boxShadow: "0 2px 4px rgba(0,0,0,0.15)",
                      }}
                    >
                      {taskCounts.DS}
                    </span>
                  )}
                </div>
                
                <svg
                  onClick={(e) => {
                    e.stopPropagation();
                    handleRefreshDailyTasks();
                  }}
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="white"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  style={{
                    cursor: "pointer",
                  }}
                  title={
                    t("refresh_daily_tasks_tooltip") || "Refresh Daily Tasks"
                  }
                >
                  <polyline points="23 4 23 10 17 10"></polyline>
                  <polyline points="1 20 1 14 7 14"></polyline>
                  <path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15"></path>
                </svg>
              </div>
            </div>
          </Accordion.Header>
          <Accordion.Body className="accordion-body-style">
            <div>
              <MyIndividualTaskList ref={myIndividualTaskListRef} />
            </div>
          </Accordion.Body>
        </Accordion.Item>

        <Accordion.Item eventKey="1">
          <Accordion.Header>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                width: "100%",
              }}
            >
              <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                <span style={{fontSize:"1rem"}}>{t("sop_related_task_header")}</span>
              </div>

              <div style={{ display: "flex", alignItems: "center", gap: "12px", marginRight:'20px' }}>
                <div style={{ position: "relative", display: "inline-block" }}>
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="white"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
                    <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
                  </svg>
                  {taskCounts.SOP > 0 && (
                    <span
                      style={{
                        position: "absolute",
                        top: "-8px",
                        right: "-8px",
                        backgroundColor: "#dc3545",
                        color: "white",
                        borderRadius: "50%",
                        minWidth: "18px",
                        height: "18px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontSize: "12px",
                        fontWeight: "600",
                        lineHeight: "1",
                        boxShadow: "0 2px 4px rgba(0,0,0,0.15)",
                      }}
                    >
                      {taskCounts.SOP}
                    </span>
                  )}
                </div>
                
                <svg
                  onClick={(e) => {
                    e.stopPropagation();
                    handleRefreshsopTask();
                  }}
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="white"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  style={{
                    cursor: "pointer",
                  }}
                  title={
                    t("refresh_sop_tasks_tooltip") || "Refresh SOP Tasks"
                  }
                >
                  <polyline points="23 4 23 10 17 10"></polyline>
                  <polyline points="1 20 1 14 7 14"></polyline>
                  <path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15"></path>
                </svg>
              </div>
            </div>
          </Accordion.Header>
          <Accordion.Body className="accordion-body-style">
            <MyTaskList ref={mySopRef} />
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>
    </div>
  );
};

export default MyTaskListManagement;